import { httpClientOmni } from "@/libraries";
import { TicketService } from "@/services";

const Types = {
  SET_LOADING: "SET_LOADING",
};

const state = {
  branch_office: [],
};

const getters = {
  getBranchOffice(state) {
    return state.branch_office;
  },
};

const mutations = {
  GET_BRANCH_OFFICE: (state, payload) => {
    state.branch_office = payload;
  },
  [Types.SET_LOADING]: (state, payload) => (state.loading = payload),
};

const actions = {
  async getBranchOffice({ commit }) {
    commit(Types.SET_LOADING, true);
    try {
      const { data: response } = await TicketService.getBranchOffice();
      // eslint-disable-next-line no-inner-declarations
      function mapping(item) {
        return {
          value: item.id,
          label: item.branch_office,
        };
      }
      let filters = response.data.map(mapping);
      commit("GET_BRANCH_OFFICE", filters);
      // return filters;
    } catch (err) {
      commit(Types.ERROR_SERVICE, err);
    }
    commit(Types.SET_LOADING, false);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
